module.exports = "https://portperrypedals.ca/_res/img/herder_family.f19aec8.jpeg";